import React, { useEffect, useState } from 'react'
import cx from 'classnames'
import styles from './EditReference.module.scss'
import EditIcon from 'components/atoms/Svgs/Edit'
import CheckIcon from 'components/atoms/Icons/Controls/Check'
import ControlledTooltip from 'components/atoms/Tooltip/ControlledTooltip'
import Tooltip from 'components/atoms/Tooltip/Tooltip'
import { validatePaymentReference } from 'utils/validation'

interface IEditReferenceProps {
  reference: string
  onReferenceUpdate: (updatedReference: string | null) => void
}

const EditReference = ({ reference, onReferenceUpdate }: IEditReferenceProps) => {
  const [editingReference, setEditingReference] = useState(false)
  const [updatedReference, setUpdatedReference] = useState<string | null>(null)
  const [referenceError, setReferenceError] = useState<string | undefined>(undefined)
  const [allowSave, setAllowSave] = useState(true)

  useEffect(() => {
    setUpdatedReference(reference)
  }, [reference])

  const saveUpdatedReference = () => {
    setEditingReference(!editingReference)
    onReferenceUpdate(updatedReference)
  }

  const onUpdatedReferenceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target
    setUpdatedReference(value)
    const error = validatePaymentReference(value)
    setReferenceError(error)
    setAllowSave(!error)
  }

  return (
    <span className={styles['amount-text']}>
      {editingReference ? (
        <Tooltip body={referenceError} isOpen={!!referenceError} place="below">
          <input
            className={cx(styles['inline-input'], { [styles['error-input']]: !!referenceError })}
            value={updatedReference || ''}
            onChange={e => onUpdatedReferenceChange(e)}
          />
        </Tooltip>
      ) : (
        <span>{reference}</span>
      )}
      {editingReference ? (
        allowSave ? (
          <CheckIcon className={styles['edit-button']} width={20} height={20} onClick={() => saveUpdatedReference()} />
        ) : (
          <CheckIcon className={styles['edit-button-disabled']} width={20} height={20} />
        )
      ) : (
        <ControlledTooltip body="Edit reference">
          <EditIcon
            className={styles['edit-button']}
            width={20}
            height={20}
            onClick={() => {
              setReferenceError('')
              setEditingReference(!editingReference)
            }}
          />
        </ControlledTooltip>
      )}
    </span>
  )
}

export default EditReference
